const SINGULAR_ADJECTIVE = { f: 'ausgewählte', m: 'ausgewählten', n: 'ausgewähltes' };

/**
 * Accusative noun phrase for the rows an action affects: the explicit selection, or every row of
 * the (filtered) table — e.g. for modal titles and confirm texts.
 *
 * @param {Object} params
 * @param {number} params.count - Rows the action covers
 * @param {boolean} params.isSelection - An explicit page selection (vs. everything in the filter)
 * @param {boolean} [params.isFiltered=false] - Table filters are active
 * @param {string} params.singular - German singular, e.g. "Firma", "Deal"
 * @param {string} params.plural - German plural, e.g. "Firmen"
 * @param {'f'|'m'|'n'} [params.gender='f'] - Grammatical gender of `singular` (accusative adjective ending)
 * @returns {string}
 */
export const describeActionTarget = ({ count, isSelection, isFiltered = false, singular, plural, gender = 'f' }) => {
	const formatted = count.toLocaleString('de-DE');
	if (isSelection) {
		return count === 1
			? `${formatted} ${SINGULAR_ADJECTIVE[gender]} ${singular}`
			: `${formatted} ausgewählte ${plural}`;
	}
	return `alle ${formatted} ${isFiltered ? 'gefilterten ' : ''}${plural}`;
};

/**
 * Label of an action row naming what its count-free buttons run on; the single place that phrases
 * this for all tables.
 *
 * @param {Object} params - See describeActionTarget
 * @returns {string}
 */
export const describeActionScope = (params) => `Aktionen für ${describeActionTarget(params)}`;
